import type {
  AnnotationCommandData,
  CommandData,
  CompanyCommandData,
  PersonCommandData,
} from '@festina/legalentity-general-types/legalentity'
import type { ExcludeString } from '@festina-life/core'

import { LegalentityRollbackCommand } from '../../actions/LegalentityRollbackCommand'
import { AddressChangeCommand } from '../../legalentityactions/AddressChangeCommand'
import { PointOfContactChangeCommand } from '../../legalentityactions/pointOfContact/PointOfContactChangeCommand'
import { LegalentityCommandModalButtonFallback } from '../LegalentityCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'

// These commands belong to no specific entity.
type MiscCommandData = Exclude<
  ExcludeString<CommandData['_type']>,
  | ExcludeString<CompanyCommandData['_type']>
  | ExcludeString<PersonCommandData['_type']>
  | ExcludeString<AnnotationCommandData['_type']>
>

export const sharedLegalentityCommands: CommandDataRecord<MiscCommandData> = {
  AddressChangeCommandData: AddressChangeCommand,
  PointOfContactChangeCommandData: PointOfContactChangeCommand,
  ChangeLegalEntityCommandData: LegalentityCommandModalButtonFallback,
  CreateMigrationPartnerV3CommandData: LegalentityCommandModalButtonFallback,
  CreateMigrationPartnerV4CommandData: LegalentityCommandModalButtonFallback,
  CreatePersonMigrationV3CommandData: LegalentityCommandModalButtonFallback,
  CreatePersonMigrationV4CommandData: LegalentityCommandModalButtonFallback,
  CreatePersonMigrationV5CommandData: LegalentityCommandModalButtonFallback,
  RollbackCommandData: LegalentityRollbackCommand,
  DeleteAddressCommandData: LegalentityCommandModalButtonFallback,
  SingleAddressChangeCommandData: LegalentityCommandModalButtonFallback,
} as const
